import {FuseRouteItemType} from '@fuse/utils/FuseUtils';

import SplitBillsPage from './SplitBillsPage';

const SplitBillsRoute: FuseRouteItemType[] = [
  {
    path: 'split-bills',
    element: <SplitBillsPage />,
    auth: null,
  },
  {
    path: 'mobot',
    element: <SplitBillsPage />,
    auth: null,
  },
];

export default SplitBillsRoute;
